import React, { useEffect, useState } from "react";
import { BsX } from "react-icons/bs";
import Dialog from "./Dialog";
import { RiQuestionLine } from "react-icons/ri";
import { IoAddCircleOutline } from "react-icons/io5";
import { Label } from "./Label";

export function Tags({
  data,
  setData,
  options,
  defaultOptions,
  allowFreeText,
  disableAdd,
  disablePopUp,
  disableSearch,
  explanation,
  titleTags,
  titleRight,
  labelExplanation,
}: {
  data: { tags: string[]; extra: string };
  setData: (d: { tags: string[]; extra: string }) => void;
  options: string[];
  defaultOptions: string[];
  allowFreeText?: boolean;
  disableAdd?: boolean;
  disableSearch?: boolean;
  disablePopUp: boolean;
  explanation?: Record<string, string>;
  titleTags?: string;
  titleRight?: string;
  labelExplanation?: string;
}) {
  const [addTag, setAddTag] = useState(false);
  const [tagInput, setTagInput] = useState("");
  const [tagExplanation, setTagExplanation] = useState<string | null>(null);
  const [showError, setShowError] = useState<string | false>(false);
  const tagLimit = 6;

  useEffect(() => {
    setTagInput("");
  }, [addTag]);

  return (
    <>
      {disablePopUp ? (
        <div className="leaver-container">
          <div className="flex flex-row">
            <label>{titleTags}</label>
            <div className="ml-auto" />
            {titleRight !== "" ? (
              <Label
                title={titleRight ? titleRight : ""}
                information={
                  labelExplanation ? (
                    <div className="text-justify">{labelExplanation}</div>
                  ) : (
                    <></>
                  )
                }
              />
            ) : null}
          </div>
          <div className="flex justify-center">
            <div
              className=" tags-container disabled-pop-up flex"
              onClick={() => {
                setAddTag(true);
              }}
            >
              {data.tags.map((tag, index) => {
                return (
                  <div
                    className="tag flex"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    key={index}
                  >
                    <div>{tag}</div>
                    {defaultOptions.includes(tag) ? null : (
                      <BsX
                        className="remove pointer"
                        onClick={() => {
                          setData({
                            ...data,
                            tags: data.tags.filter((_, i) => i !== index),
                          });
                        }}
                      />
                    )}
                  </div>
                );
              })}
            </div>
            {allowFreeText ? (
              <>
                <label>Feel free to add extra information</label>
                <textarea
                  rows={8}
                  className={"w-100"}
                  value={data.extra}
                  onChange={(e) => {
                    setData({
                      ...data,
                      extra: e.target.value,
                    });
                  }}
                />
              </>
            ) : null}
            <div className="ml-4" />
            <div className=" flex tags tags-container disabled-pop-up">
              {disableSearch ? null : (
                <input
                  type="text"
                  placeholder="Search tags"
                  className="w-100"
                  value={tagInput}
                  onChange={(e) => {
                    setTagInput(e.target.value);
                  }}
                />
              )}

              <div className="tags-list">
                {options
                  .filter((item) =>
                    item.toLowerCase().includes(tagInput.toLowerCase())
                  )
                  .filter((item) => !data.tags.includes(item))
                  .map((item, index) => {
                    const foundExplanation = explanation && explanation[item];

                    return (
                      <div
                        className="tag-item flex"
                        onClick={() => {
                          setData({
                            ...data,
                            tags: data.tags.concat(item),
                          });
                          setAddTag(false);
                        }}
                        key={index}
                      >
                        {foundExplanation ? (
                          <div
                            className="flex pointer items-center mr-2"
                            onClick={(e) => {
                              e.stopPropagation();
                              setTagExplanation(foundExplanation);
                            }}
                          >
                            <RiQuestionLine />
                          </div>
                        ) : null}
                        {item}
                      </div>
                    );
                  })}
              </div>
              <div className="flex button-group">
                {disableAdd ? null : (
                  <div
                    className="button"
                    onClick={() => {
                      setData({
                        ...data,
                        tags: data.tags.concat(tagInput),
                      });
                      setAddTag(false);
                    }}
                  >
                    Add
                  </div>
                )}
              </div>
            </div>
            <Dialog
              isOpen={tagExplanation !== null}
              onRequestClose={() => {
                setTagExplanation(null);
              }}
              title={"Explanation"}
              size={"xsmall"}
              padding={true}
            >
              {tagExplanation}
            </Dialog>
          </div>
        </div>
      ) : (
        <div className="flex flex-column">
          <label>Add tags</label>
          <div
            className="tags-container flex items-end pointer"
            onClick={() => {
              if (data.tags.length < tagLimit) {
                setAddTag(true);
                setShowError(false);
              } else {
                setShowError(`You can only add ${tagLimit} tags per founder.`);
              }
            }}
          >
            {data.tags.map((tag, index) => {
              return (
                <div
                  className="tag flex items-center"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  key={index}
                >
                  <div className="tag-text">{tag}</div>
                  {defaultOptions.includes(tag) ? null : (
                    <BsX
                      className="remove pointer"
                      onClick={() => {
                        setShowError(false);
                        setData({
                          ...data,
                          tags: data.tags.filter((_, i) => i !== index),
                        });
                      }}
                    />
                  )}
                </div>
              );
            })}
            <div
              className="add"
              onClick={() => {
                if (data.tags.length < tagLimit) {
                  setAddTag(true);
                  setShowError(false);
                } else {
                  setShowError(
                    `You can only add ${tagLimit} tags per founder.`
                  );
                }
              }}
            >
              <IoAddCircleOutline />
            </div>
          </div>
          {showError ? <div className="red"> {showError} </div> : null}
          {allowFreeText ? (
            <>
              <label>Feel free to add extra information</label>
              <textarea
                rows={8}
                className={"w-100"}
                value={data.extra}
                onChange={(e) => {
                  setData({
                    ...data,
                    extra: e.target.value,
                  });
                }}
              />
            </>
          ) : null}
          <Dialog
            isOpen={addTag}
            onRequestClose={() => {
              setAddTag(false);
            }}
            title={"Add a tag"}
            size={"xsmall"}
            padding={true}
          >
            <div className="w-100 flex flex-column tags">
              <label className="font-bold">
                {disableAdd
                  ? "Search tags"
                  : "Write your own roles and responsibilities"}
              </label>
              <div className="button-add-container flex flex-row">
                <input
                  type="text"
                  className="w-100"
                  value={tagInput}
                  onChange={(e) => {
                    setTagInput(e.target.value);
                  }}
                />
                {disableAdd ? null : (
                  <div
                    className="button add"
                    onClick={() => {
                      setData({
                        ...data,
                        tags: data.tags.concat(tagInput),
                      });
                      if (data.tags.length < tagLimit - 1) {
                        setAddTag(true);
                        setShowError(false);
                        setTagInput("");
                      } else {
                        setAddTag(false);
                      }
                    }}
                  >
                    Add
                  </div>
                )}
              </div>
              <div className="tags-list">
                {options
                  .filter((item) =>
                    item.toLowerCase().includes(tagInput.toLowerCase())
                  )
                  .filter((item) => !data.tags.includes(item))
                  .map((item, index) => {
                    const foundExplanation = explanation && explanation[item];

                    return (
                      <div
                        className="tag-item flex"
                        onClick={() => {
                          setData({
                            ...data,
                            tags: data.tags.concat(item),
                          });
                          if (data.tags.length < tagLimit - 1) {
                            setAddTag(true);
                            setShowError(false);
                          } else {
                            setAddTag(false);
                          }
                        }}
                        key={index}
                      >
                        {foundExplanation ? (
                          <div
                            className="flex pointer items-center mr-2"
                            onClick={(e) => {
                              e.stopPropagation();
                              setTagExplanation(foundExplanation);
                            }}
                          >
                            <RiQuestionLine />
                          </div>
                        ) : null}
                        {item}
                      </div>
                    );
                  })}
              </div>
              <div className="flex flex-row button-group">
                <div
                  className={`button ${disableAdd ? "" : "ml-4"}`}
                  onClick={() => {
                    setAddTag(false);
                  }}
                >
                  Done
                </div>
              </div>
            </div>
          </Dialog>
          <Dialog
            isOpen={tagExplanation !== null}
            onRequestClose={() => {
              setTagExplanation(null);
            }}
            title={"Explanation"}
            size={"xsmall"}
            padding={true}
          >
            {tagExplanation}
          </Dialog>
        </div>
      )}
    </>
  );
}
